// Duchy Fasteners Mega Menu — hover interaction with CSS injection
(function() {
  // Inject critical CSS override to fix positioning regardless of cached CSS files
  var style = document.createElement('style');
  style.id = 'duchy-mega-runtime-css';
  style.textContent = [
    '.secondary-header,.header-nav-blocks,.nav-menu-wrapper,.nav-menu-list{overflow:visible!important}',
    'li.has-duchy-mega{position:relative!important;overflow:visible!important}',
    '.duchy-mega-panel{display:none!important;position:absolute!important;top:100%!important;left:0!important;right:0!important;width:100vw!important;background:#fff!important;border-top:3px solid #1a7a3f!important;box-shadow:0 8px 32px rgba(0,0,0,.18)!important;z-index:99999!important;padding:28px 40px 32px!important}',
    'li.has-duchy-mega.open>.duchy-mega-panel{display:block!important;visibility:visible!important;opacity:1!important;pointer-events:auto!important}',
    '@media(max-width:990px){.duchy-mega-panel{display:none!important}}'
  ].join('');
  document.head.appendChild(style);

  function initDuchyMegaMenu() {
    var duchyItems = document.querySelectorAll('.has-duchy-mega');
    if (!duchyItems.length) return;
    duchyItems.forEach(function(li) {
      var closeTimer;
      li.addEventListener('mouseenter', function() {
        clearTimeout(closeTimer);
        // Close all other duchy mega items
        duchyItems.forEach(function(other) {
          if (other !== li) other.classList.remove('open');
        });
        li.classList.add('open');
      });
      li.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(function() {
          li.classList.remove('open');
        }, 80);
      });
    });
    // Close on click outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.has-duchy-mega')) {
        duchyItems.forEach(function(li) {
          li.classList.remove('open');
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDuchyMegaMenu);
  } else {
    initDuchyMegaMenu();
  }
})();
